import i18n from "@/lib/i18next";
import { isSupportedLanguage, type SupportedLanguage } from "@pulse/i18n";

/** Active UI/content language from i18next (not the normalized settings mirror). */
export function activeLanguage(): SupportedLanguage {
  const code = (i18n.resolvedLanguage ?? i18n.language ?? "de").slice(0, 2);
  return isSupportedLanguage(code) ? code : "de";
}
